module.exports = __webpack_public_path__ + "img/1.3eac165.png";